export const convertTimestampToHHMM = (timestamp: number) => {
  // Create a Date object from the timestamp
  const date = new Date(timestamp)

  // Extract hours and minutes
  let hours: number | string = date.getHours()
  let minutes: number | string = date.getMinutes()

  hours = hours.toString().padStart(2, '0')
  minutes = minutes.toString().padStart(2, '0')

  const formattedTime = `${hours}:${minutes}`

  return formattedTime
}
